import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { formatDataBeforeView } from '../../../helpers/GeneralHelper';

export const OnboardView = ({module, showModal, setShowModal, data}) => {

  const inputFields = {
    client_name: 'Client',
    requirement_name: 'Requirement',
    candidate_name: 'Candidate',
    onboard_total_exp: 'Years of Experience (Total)',
    onboard_relevant_exp: 'Years of Experience (Relevant)',
    onboard_previous_employer: 'Previous Employer',
    onboard_notice_period: 'Notice Period',
    onboard_can_join: 'Can Join?',
    onboard_native: 'Native',
    onboard_previous_designation: 'Previous Designation',
    onboard_previous_ctc: 'Offered CTC',
    onboard_expected_ctc: 'Previous CTC',
    onboard_offered_ctc: 'Expected CTC',
    onboard_is_pf: 'PF',
    onboard_is_vendor: 'Vendor',
    onboard_vendor_email: 'Vendor Email',
    onboard_vendor_fee: 'Vendor Fee',
    onboard_doj: 'Date of Joining',
    onboard_present_location: 'Present Location (City)',
    onboard_work_location: 'Work Location (City)',
    onboard_br_approved: 'BR Approved? (p.m)',
    onboard_br_tax: 'BR Tax',
    onboard_gpm: 'GPM over Bill Rate (%)',
    onboard_gp_month: 'GP per Month',
    onboard_sales_spoc: 'Sales Spoc',
    onboard_business_unit: 'Business Unit',
    onboard_account_manager: 'Account Manager',
    onboard_account_coordinator: 'Account Coordinator',
    onboard_update_time: 'Updated At',
    onboard_create_time: 'Created At',
  }
  const formatOptions = [
    {
      'type': 'yesNo',
      'column': 'onboard_can_join',
    },
    {
      'type': 'yesNo',
      'column': 'onboard_is_pf',
    },
    {
      'type': 'yesNo',
      'column': 'onboard_is_vendor',
    },
    {
      'type': 'yesNo',
      'column': 'onboard_br_approved',
    },
    {
      'type': 'date',
      'column': 'onboard_doj',
    },
    {
      'type': 'datetime',
      'column': 'onboard_update_time',
    },
    {
      'type': 'datetime',
      'column': 'onboard_create_time',
    },
  ];

  const [fields, setFields] = useState(inputFields);
  useEffect(() => {
    if (data) {
      setFields(formatDataBeforeView(data, formatOptions));
    }
  }, [data]);

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
      <Modal.Header closeButton>
          <Modal.Title>View {module.singularTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-bordered table-hover table-sm">
          <tbody>
            {Object.keys(inputFields).map((item) => 
              <tr key={item}>
                <td>{inputFields[item]}</td>
                <th>{fields[item]}</th>
              </tr>
            )}
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  );
};
